import { render, staticRenderFns } from "./honoraryAwards.vue?vue&type=template&id=6a742524&scoped=true&"
import script from "./honoraryAwards.vue?vue&type=script&lang=js&"
export * from "./honoraryAwards.vue?vue&type=script&lang=js&"
import style0 from "./honoraryAwards.vue?vue&type=style&index=0&id=6a742524&prod&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a742524",
  null
  
)

export default component.exports